var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cargo-advance-select", {
    attrs: {
      "select-type": _vm.TYPE_NAMES.basic_data_Office,
      headers: _vm.headers,
      fields: _vm.fields,
      "tag-name": _vm.tagName,
      "tag-value": _vm.tagValue,
      "static-options": _vm.staticOptions,
      filterable: "",
      placeholder: _vm.placeholder,
      "callback-params": _vm.callbackParams,
      "default-value": _vm.defaultValue
    },
    on: {
      enter: function($event) {
        return _vm.$emit("enter")
      },
      parentCallBack: function(data) {
        return _vm.$emit("parentCallBack", data)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }